import { Button, Spinner } from "react-bootstrap";
import { useEffect, useState } from 'react';
import {  useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {  SessionKeys } from "../utils/AppUtils";
import FooterNew from   "../components/FooterNew"; 
import HeaderLogoSection from "../components/HeaderLogoSection";
import _ from "lodash"
import Loader from "../components/Loader/Loader";
import MESSAGE from "../utils/messages"; 
import {fetchTimezoneArray} from "../redux/user/actions";
import { onSubmitAccessCodeData} from "../redux/auth/actions";

const AccessCodePage = () => {

  const dispatch = useDispatch();
  const authBroker = useSelector((state) => state.auth.authBroker);


//   const [htmlFormError, setFormError] = useState('')
//   const [htmlFormSuccess, setFormSuccess] = useState('')
 
  const [isUserAlreadyLogin, setIsUserAlreadyLogin] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [infoModal, setInfoModal] = useState(false)
  const [showInfoModalMsg, setShowInfoModalMsg] = useState(MESSAGE.ACTIVE_IN_OTHER_TAB)
  const [showSpinner, setShowSpinner] = useState(false)

  
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [timeZone, setTimeZone] = useState("");
  const [accessCode, setAccessCode] = useState("");
  const [timezoneList, setTimezoneList] = useState([]);



  const timezoneArray = useSelector((state) => state.user.timezoneMaster);
  const respdata = useSelector((state)=>state.auth.accessCodeDataRes);
  console.log("respdata after refresh",respdata);

  useEffect(() => {
    dispatch(
        fetchTimezoneArray({
            module: "getTimezone",
            postData: {},
        })
    );
}, [dispatch]);

const [apiCall, setApiCall] = useState(false);
const [successMessage, setSuccessMessage] = useState("");
const [errorMessage, setErrorMessage] = useState("");

useEffect(() => {
    if (!_.isEmpty(respdata)) {
      console.log("respdata",respdata);
        if(apiCall)
        {
        if(respdata?.status==="error") {
            console.log("resp in useEfffect",respdata);
            setSuccessMessage("");
            setErrorMessage(respdata.error.message);
            setTimeout(() => {
              setErrorMessage("");
            }, 10000);
           
          }
        else if (respdata?.status==="success") {     
            reset();
            setSuccessMessage("Thank you for Signup, we have sent an email for verification and setting your password. Please note that the access code is valid till 30 days from today.");
            setTimeout(() => {
              setSuccessMessage("");
            }, 10000);
          } 
        else if(respdata?.status==="false")
        {
            setSuccessMessage("");
            setErrorMessage(respdata?.message);
             setTimeout(() => {
              setErrorMessage("");
            }, 10000);
        }
        setIsLoading(false);
    }
    }
}, [respdata]);


  useEffect(() => {
    if (!_.isEmpty(timezoneArray)) {
        if (timezoneArray.status === "success") {
            setTimezoneList(timezoneArray.payload.payload);
        } else {
            setTimezoneList([]);
        }
    }
}, [timezoneArray]);
  
  useEffect(() => {
    if (document.getElementById("id_page_404") !== null) {
      document.getElementById("id_page_404").style.display = "none";
    }
  }, [])

  useEffect(() => {
    if (
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER) !== null &&
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER) !== "" &&
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER) !== undefined
    ) {
      if (authBroker.status === "success") {
        setInfoModal(true)
        setIsUserAlreadyLogin(true)
        setIsLoading(false)
      }
    } else {
      setIsLoading(false)
    }
}, [authBroker])

//   useEffect(() => {
//     if (htmlFormError) {
//       setTimeout(() => {
//         setFormError('')
//       }, 2000)
//     } else if (htmlFormSuccess) {
//       setTimeout(() => {
//         setFormSuccess('')
//       }, 2000)
//     }
//   }, [htmlFormError, htmlFormSuccess])


  const reset = () => {
    setFirstName("");
    setMiddleName("");
    setLastName("");
    setEmail("");
    setTimeZone("");
    setAccessCode("");
    setErrorMessage("");
  }

  const submitHandler = (event) =>{
    setIsLoading(true);
    setApiCall(true);
    if(timeZone)
    {
    dispatch(onSubmitAccessCodeData({
            module: "onSubmitAccessCodeData",
            postData: {
                 entity_type: "add-user-entity",
                first_name: firstName,
                middle_name: middleName,
                last_name: lastName,
                email: email,
                access_code: accessCode,
                timezone: timeZone
            },
         })
    );
        }
        else{
            event.target.reportValidity();
        }
}

const resetMessage = () => {
    reset();
    setErrorMessage("");
    setSuccessMessage("");
}

  return (
    <>
    <div className="page-wrapper-rsp">
      <HeaderLogoSection />
      <div className="header-border"></div>
      <Loader start={isLoading} />
      <section className="setup-password">
        <div className="container">
          <div className="row">
            {isUserAlreadyLogin ?
              <div className="col-md-12 messgebox">
                <div className="alert-card d-flex justify-content-center topsecalert "> 
                  <div className="shop-cart order-details alert-notify-sucess">
                    <div className="shop-info justify-content-center">
                        {showInfoModalMsg} 
                    </div>
                  </div>
                </div> 
              </div>
            : ''
            }
            <div className={`row ${isUserAlreadyLogin ? "blur-section" : ""}`}>
              <div className="col-md-12">
              <div className="heading">
                <h3>Sign up with Access Code</h3> 
                </div>
                {successMessage ? <span style={{color:'#146c43',display:"inline-block",paddingBottom:'5px'}}>{successMessage}</span> : errorMessage? <span style={{color:'#dc3545',paddingBottom:'5px',display:"inline-block"}}>{errorMessage}</span> :<></>}
              </div>

              <div className="col-md-12">
              <form onSubmit={(event) => {
                event.preventDefault();
                submitHandler(event);
              }}>
                <div className="row">
                
               <div className="col-md-6 col-lg-4 col-xl-4 col-12">
                <div className="input-text position-relative">
                  <label htmlFor="firstname" className="input__label">First Name<span style={{color:'red'}}>*</span></label>
                  <input type="firstname" className="input__field"
                    placeholder="Enter First Name"
                    aria-label="firstname" aria-describedby="basic-addon1"
                    disabled={isUserAlreadyLogin}
                    required
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)} />
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-4 col-12">
                <div className="input-text position-relative">
                  <label htmlFor="middlename" className="input__label">Middle Name</label>
                  <input type="middlename" className="input__field"
                    placeholder="Enter Middle Name"
                    aria-label="middlename" aria-describedby="basic-addon1"
                    disabled={isUserAlreadyLogin}
                    value={middleName}
                    onChange={(e) => setMiddleName(e.target.value)} />
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-4 col-12">
                <div className="input-text position-relative">
                  <label htmlFor="lastname" className="input__label">Last Name<span style={{color:'red'}}>*</span></label>
                  <input type="lastname" className="input__field"
                    placeholder="Enter Last Name"
                    aria-label="lastname" aria-describedby="basic-addon1"
                    disabled={isUserAlreadyLogin}
                    required
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)} />
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-4 col-12">
                <div className="input-text  position-relative">
                  <label htmlFor="email" className="input__label">Email<span style={{color:'red'}}>*</span></label>
                  <input type="email" className="input__field" placeholder="Enter Email Address"
                    aria-label="email" aria-describedby="basic-addon1"
                    disabled={isUserAlreadyLogin}
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)} 
                    />
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-4 col-12">
                <div className="input-text  position-relative reg-select">
                     <label htmlFor="category" className="input__label">
                            Timezone<span style={{color:'red'}}>*</span>
                        </label>
                        <select
                            className="form-select input_searchfield"
                            id="category"
                            aria-label="Default select example"
                            disabled={isUserAlreadyLogin}
                            required
                            onChange={(ev) => {
                                setTimeZone(ev.target.value);
                            }}
                            value={timeZone}
                            onInvalid={(e) => e.target.setCustomValidity('Please select timezone')}
                            // Reset the custom validation message when the field becomes valid
                            onInput={(e) => e.target.setCustomValidity('')}
                        >
                            <option value="">Select Timezone</option>
                            {timezoneList.map((cat, index) => {
                                return (
                                    <option
                                        value={cat.offset}
                                        key={index}
                                    >
                                        {cat.timezone}{" "}
                                    </option>
                                );
                            })}

                        </select>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 col-xl-4 col-12">
                <div className="input-text  position-relative">
                  <label htmlFor="access_code" className="input__label">Access Code<span style={{color:'red'}}>*</span></label>
                  <input type="access_code" className="input__field" placeholder="Enter Access Code"
                    aria-label="access_code" aria-describedby="basic-addon1"
                    disabled={isUserAlreadyLogin}
                    onChange={(e) => setAccessCode(e.target.value)} 
                    required
                    value={accessCode}
                    />
                </div>
              </div>
              <div className="col-md-12 d-flex gap-3 justify-content-end mt-3">
                <div className="save_button">
                  {
                    showSpinner ?
                    <Button
                    className="btn btn-primary setup-button" >
                      <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      />
                    </Button>
                    :
                    <Button 
                    type="reset"
                    onClick={()=>resetMessage()}
                    className="btn btn-primary setup-button" 
                    disabled={isUserAlreadyLogin}>
                    Reset</Button>
                  }
                  {/* {htmlFormError && (<div>{htmlFormError}</div>)}
                  {htmlFormSuccess && (<div>{htmlFormSuccess}</div>)} */}
                </div>
                <div className="save_button">
                  {
                    showSpinner ?
                    <Button
                    className="btn btn-primary setup-button" >
                      <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      />
                    </Button>
                    :
                    <Button 
                    type="submit"
                    className="btn btn-primary setup-button" 
                    disabled={isUserAlreadyLogin}>
                    Submit</Button>
                  }
                  {/* {htmlFormError && (<div>{htmlFormError}</div>)}
                  {htmlFormSuccess && (<div>{htmlFormSuccess}</div>)} */}
                </div>
              </div>
              </div>
              </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FooterNew />
      </div>
    </>
  )

}
export default AccessCodePage;